<div class="container">
  <h3>Request an RCR Exchange</h3>

  <invd-rcr-exchange-error-message
    *ngIf="exchangeHasError"
    [title]="exchangeErrorMessage.title"
    [description]="exchangeErrorMessage.description"
    [suggestions]="exchangeErrorMessage.suggestions"
  >
  </invd-rcr-exchange-error-message>

  <div class="row exchange-type">
    <div class="col-12 col-sm-12 col-md-6 col-lg-6 dealer-trader-form">
      <ng-container *ngIf="isInternalUsr">
        <h5 class="request-an-exchange-heading">First, select your Dealer and Trader</h5>
        <div class="dealer-trader-block">
          <form class="dealer-trader-form" #f="ngForm" [formGroup]="requestExchangeForm">
            <div class="dealer-control-block col-12 col-sm-12 col-md-4 col-lg-4">
              <h5>Dealer</h5>
              <div class="dropdown button custom-select">
                <select
                  class="invd-select-button"
                  name="dealer"
                  formControlName="dealerControl"
                  [ngModel]="selectedDealer"
                  (ngModelChange)="setSelectedDealer($event)"
                >
                  <option disabled [ngValue]="null">Select dealer</option>
                  <option
                    *ngFor="let dealer of dealers; trackBy: trackByIdentity"
                    [ngValue]="dealer"
                  >
                    {{ dealer.dealerName }}
                  </option>
                </select>
              </div>
            </div>

            <ng-container *ngIf="selectedDealer == null">
              <div class="trader-control-block col-12 col-sm-12 col-md-4 col-lg-3">
                <h5>Approved Trader</h5>
                <div class="dropdown button custom-select">
                  <select
                    class="invd-select-button"
                    name="trader"
                    formControlName="traderControl"
                    [ngModel]="selectedTrader"
                    (ngModelChange)="setSelectedTrader($event)"
                  >
                    <option disabled [ngValue]="null">Select trader</option>
                  </select>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="selectedDealer != null">
              <div class="trader-control-block col-12 col-sm-12 col-md-4 col-lg-3">
                <h5>Approved Trader</h5>
                <div class="dropdown button custom-select">
                  <select
                    class="invd-select-button"
                    name="trader"
                    formControlName="traderControl"
                    [ngModel]="selectedTrader"
                    (ngModelChange)="setSelectedTrader($event)"
                  >
                    <option disabled [ngValue]="null">Select trader</option>
                    <option
                      *ngFor="let trader of selectedDealer.traders; trackBy: trackByIdentity"
                      [ngValue]="trader"
                    >
                      {{ trader.traderFirstName + ' ' + trader.traderLastName }}
                    </option>
                  </select>
                </div>
              </div>
            </ng-container>
          </form>
        </div>
        <h5 class="request-an-exchange-sub-heading">Then, enter your CUSIP or Deal Number</h5>
      </ng-container>
      <h5 *ngIf="!isInternalUsr" class="request-an-exchange-sub-heading">
        Enter your CUSIP or Deal Number
      </h5>
      <div>
        <div class="input-search col-12 col-sm-12 col-md-12 col-lg-8 exchange-type-input-lookup">
          <invd-fm-input-with-validations-for-request-an-exchange
            [isTraderSel]="isTraderSelected"
            (dealSearch)="dealSearch($event)"
          >
          </invd-fm-input-with-validations-for-request-an-exchange>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-6 col-lg-6 format-table-block">
      <h5 class="request-an-exchange-heading">Format Table</h5>
      <div>
        <p>
          <br />You may refer to the list below when inputting your <br />CUSIP or Deal Number to
          ensure correct format.<br />
        </p>
      </div>

      <div>
        <p class="format-table-paragraph">
          CUSIP : <br />
          SMBS : <br />
          Single Family REMIC : <br />
          Grantor Trust REMIC : <br />
          Whole Loan REMIC : <br />
          Benchmark REMIC : <br />
          Multi-Family REMIC :
        </p>
        <p class="format-table-paragraph">
          #########(eg. 3136BB2J0)<br />
          ### (eg. 412)<br />
          yyyy-### (eg. 2020-001)<br />
          yyyy-T## (eg. 2011-T01)<br />
          yyyy-W## (eg. 2005-W01)<br />
          yyyy-B## (eg. 2007-B01)<br />
          yyyy-M## (eg. 2020-M01)
        </p>
      </div>
    </div>
  </div>
</div>
